import TitleBlock from '@anm/components/TitleBlock';
import { flexCenter } from '@anm/styles/helpers';
import styled from 'styled-components';

const AlertBlockWrapper = styled.div<{ maxWidth: number }>`
  ${flexCenter};
  flex-direction: column;
  text-align: center;
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth}px;
  margin: 0 auto;
  font-weight: 400;
  button {
    margin-top: 17px;
    min-width: 115px;
  }
`;

export const AlertTitleBlock = styled(TitleBlock)`
  margin-bottom: 7px;
  padding: 0 20px;
`;

export default AlertBlockWrapper;
